'use client';

import * as React from 'react';
import Image from 'next/image';

import { cn } from '@/lib/utils';
import mapPrismicImageProxy from '@/utils/prismic/mapPrismicImageProxy';

import Section from '@/components/layout/Section';

type ImageDataType = {
    src: string;
    alt: string;
    width?: number;
    height?: number;
};

export interface ImageSectionProps extends React.HTMLAttributes<HTMLDivElement> {
    align?: 'center' | 'left' | 'full' | null | undefined;
    image: ImageDataType | null;
}

const ImageSection = ({ align, image }: ImageSectionProps) => {
    if (!image || !image.src) return null;

    return (
        <Section>
            <div
                className={cn('w-full', {
                    'flex justify-center': align === 'center',
                    'flex justify-start': align === 'left',
                })}
            >
                <Image
                    src={mapPrismicImageProxy(image.src)}
                    alt={image.alt}
                    width={image.width}
                    height={image.height}
                    className={cn('h-auto', {
                        'w-full': !align || align === 'full',
                        'max-h-[450px] max-w-full object-contain':
                            align === 'full',
                    })}
                />
            </div>
        </Section>
    );
};

export default ImageSection;
